import { BACKORDERS_CRUD_ACTION_CREATORS } from '../actions/backorders_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const backordersRestCrudThunksForBuyer = new RestCrudThunks(
	'backorders',
	'backorder',
	'backorder',
	'backorders',
	BACKORDERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'inventory/stock_locations/'
);
export const backordersRestCrudThunksForSupplier = new RestCrudThunks(
	'backorders',
	'backorder',
	'backorder',
	'backorders',
	BACKORDERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/stock_locations/'
);
